export const computeFileExtension = (
  fileName: string | undefined,
): string | null => {
  if (fileName?.includes('.')) {
    // @ts-expect-error TS(2532): Object is possibly 'undefined'.
    return fileName.split('.').pop().toLowerCase();
  }

  return null;
};

export const getVersionAndTypeBeingDisplayed = (
  fileName: string,
): {
  fileName: string;
  ext: string | undefined;
  version: string | null;
} => {
  const [, rest] = fileName.split('_');
  const ext = fileName.split('.').at(-1);

  if (!rest) {
    return { fileName, ext, version: 'original' };
  }

  const splitRest = rest.split('.');
  const version = splitRest.slice(0, splitRest.length - 1).join('.');

  return { fileName, ext, version };
};

/**
 * Generates a PDF filename with optional name sanitization
 *
 * @param prefix - The prefix for the filename (e.g., "claim-summary", "benefits-summary")
 * @param id - The unique identifier to append
 * @param name - Optional name to include (will be sanitized)
 * @returns The generated filename with .pdf extension
 */
export const generatePdfFilename = (
  prefix: string,
  id: string,
  name?: string,
): string => {
  const sanitizedName = name
    ?.replace(/[^a-zA-Z0-9\s-]/g, '')
    .replace(/\s+/g, '-');

  const filename = sanitizedName
    ? `${prefix}-${sanitizedName}-${id}`
    : `${prefix}-${id}`;

  return `${filename}.pdf`;
};
